export default "__VITE_ASSET__c626b4c0__"